// import React, { useRef } from "react";
import { BellOutlined, DeleteOutlined, EditOutlined, EyeOutlined, InfoOutlined, ShoppingCartOutlined, TagOutlined } from "@ant-design/icons"
// import EmptyComponentLinkText from '../../../components/EmptyComponent/EmptyComponentLinkText';
import { useNavigate } from 'react-router-dom'
import { CHANNELTYPE, dataOptionStatus } from "../../../services/data"
import ModalDeleteManager from "../../../components/ModalDeleteManager"
import { useMemo, useState } from "react"
import ShowNotification from "./ShowNotification"
import useToast from "../../../hook/useToast"
import { URL_TEMPLATE_IMG } from "../../../env"
import { network_operator } from "../../../components/ExportImgFigma"
import type { ColDef, ICellRendererParams } from "ag-grid-community";
import { ConfigProvider, Pagination, Switch, Tooltip } from "antd";
import { AgGridReact } from "ag-grid-react"
import viVN from 'antd/locale/vi_VN';

import { NodataTable } from "../../../components/NoDataTable"
import { checkDisabledPermission, dataPagination, getUserPermissions } from "../../../until"
import { useSelector } from "react-redux"
import { selectorPermission } from "../../../store/slices/permissionSlice"
import { formatNumber } from "../../../services/mixin"
import { IPagination } from "../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup"
import { INotificationTemplate } from "../../../api/notificationTemplate/notificationTemplateApi"

export interface ZnsTemplateRow {
  id: number;
  code: string;
  name: string;
  brand: string;
  znsType: string;
  costType: string;
  creator: string;
  createdAt: string;
  isActive: boolean;
}

interface Props {
  paginations: Record<CHANNELTYPE, IPagination>
  dataTemplates: Record<CHANNELTYPE, INotificationTemplate[]>
  gInfoNotificationTemplate: (id: number) => void
  uStatusNotificationTemplate: (id: number) => void
  openModalDelete: (id: number) => void
  onPaginationChange: ((page: number, pageSize: number) => void)
}
const Email: React.FC<Props> = ({
  paginations, dataTemplates,
  gInfoNotificationTemplate, uStatusNotificationTemplate, openModalDelete, onPaginationChange
}) => {

  const navigate = useNavigate()
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, } = getUserPermissions(permissionSlice, location.pathname)

  const columnDefs = useMemo<ColDef<any>[]>(() => [
    {
      headerName: 'Hành động',
      field: 'action',
      colId: 'action',
      width: 203,
      resizable: false,
      suppressMovable: true,
      lockPosition: 'left',
      headerComponentParams: {
        template: '<span class="w-full flex items-center justify-center">Hành động</span>'
      },
      cellRenderer: (params: ICellRendererParams) => {
        const { id, view, status } = params.data;
        return (
          <div className="h-full d-flex align-center justify-center gap-10-px">
            <EyeOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
              onClick={() => { gInfoNotificationTemplate(id) }}
            />
            <EditOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
              onClick={() =>
                navigate(`/marketing/notification-templates-management/edit-email`,
                  {
                    state: { id: id, type: CHANNELTYPE.EMAIL }
                  })}
            />
            <DeleteOutlined
              className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(isdelete)}`}
              onClick={() => openModalDelete(id)}
            />
            <Switch
              disabled={!edit}

              checked={status}
              // defaultChecked={!!view}
              onChange={() => {
                uStatusNotificationTemplate(Number(id));
              }}
              className="rs-switch rs-switch--sm"
            />
          </div>
        );
      }
    },
    {
      headerName: "Mã mẫu",
      field: "code",
      sortable: true,
    },
    {
      headerName: "Tên mẫu thông báo",
      field: "title",
    },
    {
      headerName: "Thương hiệu",
      field: "categories",
    },
    {
      headerName: "Nội dung",
      field: "content",
      cellRenderer: (params: ICellRendererParams) => {
        const content = params.data.content || '';
        const tempElement = document.createElement('div');
        tempElement.innerHTML = content;
        const textContent = tempElement.textContent || tempElement.innerText || '';
        return (
          <Tooltip
            color="white"
            overlayInnerStyle={{
              color: "#475467",
              maxHeight: '50vh',
              overflowY: 'auto',
              width: '500px',
            }}
            title={<div className="" dangerouslySetInnerHTML={{ __html: content }}></div>}

          >
            <div className="">

              {textContent}
            </div>
          </Tooltip>
        );
      }
    },
    {
      headerName: "Người tạo",
      field: "adminName",
    },
    {
      headerName: "Ngày tạo",
      field: "createdAt",
      sortable: true,
    },

  ], [dataTemplates[CHANNELTYPE.EMAIL]]); // Chỉ các hàm setState


  return (
    <div className='gap-4 '>

      <div className={`order-history-card__body custom-page-css flex flex-col flex-1 justify-between`}>
        <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
          <AgGridReact
            className="my-auto-height-grid" getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            rowData={dataTemplates[CHANNELTYPE.EMAIL]}
            rowHeight={55}
            columnDefs={columnDefs}
            // rowSelection="multiple"
            overlayNoRowsTemplate={NodataTable}
            suppressDragLeaveHidesColumns={true}
          />

        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination showSizeChanger current={paginations[CHANNELTYPE.EMAIL].current} pageSize={paginations[CHANNELTYPE.EMAIL].pageSize} total={paginations[CHANNELTYPE.EMAIL].total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(paginations[CHANNELTYPE.EMAIL].total, paginations[CHANNELTYPE.EMAIL].pageSize,
                paginations[CHANNELTYPE.EMAIL].current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}
            />
          </div>
        </ConfigProvider>
      </div>

    </div>
  )
}

export default Email
